import { styled } from "@linaria/react";
import React, { HTMLAttributes } from "react";

function InnerContainer(
  props: React.PropsWithChildren<HTMLAttributes<HTMLDivElement>>
): JSX.Element {
const {children, ...otherProps} = props
  return <OutterDiv {...otherProps}>{children}</OutterDiv>;
}

export default InnerContainer;

const OutterDiv = styled.div`
  background-color: white;
  border-radius: 24px;
  padding: 24px;
`;
